import styled, { css } from 'styled-components'

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    gap: ${theme.space['16']};
    padding: ${theme.space['40']};
  `,
)

export const Image = styled.img(
  () => css`
    width: 6.4rem;
    height: 6.4rem;
  `,
)

export const Title = styled.span(
  () => css`
    text-align: center;
  `,
)

export const Description = styled.span(
  () => css`
    text-align: center;
    max-width: 30rem;
  `,
)
